var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 25.9,
    y: 45.1,
    width: 44.6,
    height: 2.78,
    viewBox: "0 0 44.6074 2.77778",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.2185 2.77778H1.38889C0.622222 2.77778 0 2.15556 0 1.38889C0 0.622222 0.622222 0 1.38889 0H43.2185C43.9852 0 44.6074 0.622222 44.6074 1.38889C44.6074 2.15556 43.9852 2.77778 43.2185 2.77778Z",
    fill: "#304A19"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25.9,
    y: 60.84,
    width: 33.36,
    height: 2.78,
    viewBox: "0 0 33.363 2.77778",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.9741 2.77778H1.38889C0.622222 2.77778 0 2.15556 0 1.38889C0 0.622222 0.622222 0 1.38889 0H31.9741C32.7407 0 33.363 0.622222 33.363 1.38889C33.363 2.15556 32.7407 2.77778 31.9741 2.77778Z",
    fill: "#304A19"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25.9,
    y: 76.96,
    width: 37,
    height: 3.1,
    viewBox: "0 0 37.0112 3.09444",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.6223 3.09444C35.6223 3.09444 35.613 3.09444 35.6093 3.09444L1.37599 2.77778C0.609327 2.77037 -0.00734137 2.14259 6.60406e-05 1.37592C0.00747345 0.612962 0.627844 0 1.38896 0C1.39266 0 1.39822 0 1.40192 0L35.6353 0.316665C36.4019 0.324073 37.0186 0.951852 37.0112 1.71852C37.0038 2.48148 36.3834 3.09444 35.6223 3.09444Z",
    fill: "#304A19"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25.9,
    y: 94.12,
    width: 23.02,
    height: 2.78,
    viewBox: "0 0 23.0167 2.77777",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6278 2.77777H1.38889C0.622222 2.77777 0 2.15555 0 1.38888C0 0.622217 0.622222 0 1.38889 0H21.6278C22.3944 0 23.0167 0.622217 23.0167 1.38888C23.0167 2.15555 22.3944 2.77777 21.6278 2.77777Z",
    fill: "#304A19"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 70.86,
    y: 105.18,
    width: 21.38,
    height: 21.4,
    viewBox: "0 0 21.3866 21.3889",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4739 1.38932L1.38849 11.4748L9.91305 19.9993L19.9985 9.91388L11.4739 1.38932Z",
    fill: "#A8C783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.91296 21.387C9.55741 21.387 9.20185 21.2518 8.93148 20.9796L0.40741 12.4556C0.146299 12.1944 0 11.8426 0 11.4741C0 11.1056 0.146299 10.7518 0.40741 10.4926L10.4926 0.40741C10.7537 0.146299 11.1056 0 11.4741 0C11.8426 0 12.1963 0.146299 12.4556 0.40741L20.9796 8.93148C21.5222 9.47407 21.5222 10.3537 20.9796 10.8963L10.8944 20.9815C10.6241 21.2518 10.2685 21.3889 9.91296 21.3889V21.387ZM3.35185 11.4741L9.91296 18.0352L18.0333 9.91481L11.4722 3.3537L3.35185 11.4759V11.4741Z",
    fill: "#364920"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 28.04,
    y: 112.02,
    width: 56.76,
    height: 56.76,
    viewBox: "0 0 56.7623 56.7623",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.6303 4.62108L4.62107 38.6303C2.06892 41.1824 2.06893 45.3203 4.62108 47.8724L8.8899 52.1413C11.4421 54.6934 15.5799 54.6934 18.132 52.1413L52.1413 18.1321C54.6934 15.5799 54.6934 11.4421 52.1413 8.88991L47.8724 4.62108C45.3203 2.06893 41.1824 2.06893 38.6303 4.62108Z",
    fill: "#A8C783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.511 55.4428C11.3943 55.4428 9.40355 54.6187 7.90725 53.1224L3.63873 48.8539C2.14243 47.3576 1.31836 45.3669 1.31836 43.2502C1.31836 41.1336 2.14243 39.1428 3.63873 37.6465L37.648 3.63727C39.1443 2.14097 41.135 1.31689 43.2517 1.31689C45.3684 1.31689 47.3591 2.14097 48.8554 3.63727L53.1239 7.90579C56.2128 10.9947 56.2128 16.0224 53.1239 19.1132L19.1147 53.1224C17.6184 54.6187 15.6276 55.4428 13.511 55.4428ZM43.2498 4.09467C41.8758 4.09467 40.5832 4.62986 39.611 5.60208L5.60169 39.6113C4.62947 40.5836 4.09428 41.8762 4.09428 43.2502C4.09428 44.6243 4.62947 45.9169 5.60169 46.8891L9.87021 51.1576C10.8424 52.1299 12.135 52.665 13.5091 52.665C14.8832 52.665 16.1758 52.1299 17.148 51.1576L51.1573 17.1484C53.1628 15.1428 53.1628 11.8762 51.1573 9.8706L46.8887 5.60208C45.9165 4.62986 44.6239 4.09467 43.2498 4.09467Z",
    fill: "#364920"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 71.16,
    y: 32.54,
    width: 93.74,
    height: 93.74,
    viewBox: "0 0 93.7463 93.7444",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M79.0333 14.7111C61.2704 -3.05185 32.4722 -3.05185 14.7111 14.7111C-3.05185 32.4741 -3.05185 61.2722 14.7111 79.0333C32.4741 96.7944 61.2722 96.7963 79.0333 79.0333C96.7963 61.2704 96.7963 32.4722 79.0333 14.7111ZM70.1185 70.1185C57.2796 82.9574 36.463 82.9574 23.6241 70.1185C10.7852 57.2796 10.7852 36.463 23.6241 23.6241C36.463 10.7852 57.2796 10.7852 70.1185 23.6241C82.9574 36.463 82.9574 57.2796 70.1185 70.1185Z",
    fill: "#A8C783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.8741 93.7444C34.3537 93.7444 22.5833 88.8685 13.7296 80.0167C4.87593 71.1648 0 59.3944 0 46.8741C0 34.3537 4.87593 22.5833 13.7296 13.7296C22.5815 4.87593 34.3519 0 46.8722 0C59.3926 0 71.163 4.87593 80.0167 13.7296C88.8704 22.5815 93.7463 34.3519 93.7463 46.8722C93.7463 59.3926 88.8704 71.163 80.0167 80.0167C71.1648 88.8685 59.3945 93.7444 46.8759 93.7444H46.8741ZM46.8722 2.77778C35.0944 2.77778 24.0222 7.36481 15.6944 15.6926C7.36482 24.0204 2.77963 35.0944 2.77963 46.8722C2.77963 58.65 7.36667 69.7222 15.6944 78.05C24.0241 86.3778 35.0963 90.9648 46.8741 90.9648C58.6519 90.9648 69.7241 86.3778 78.0519 78.05C86.3796 69.7204 90.9667 58.6482 90.9667 46.8704C90.9667 35.0926 86.3796 24.0204 78.0519 15.6926C69.7241 7.36481 58.65 2.77778 46.8722 2.77778ZM46.8704 81.1204C38.0963 81.1204 29.3204 77.7796 22.6407 71.1C9.28148 57.7389 9.28148 36.0019 22.6407 22.6407C36 9.27963 57.7389 9.28148 71.1 22.6407C84.4593 36 84.4593 57.7389 71.1 71.1C64.4204 77.7796 55.6444 81.1204 46.8704 81.1204ZM46.8704 15.3981C38.8056 15.3981 30.7445 18.4667 24.6056 24.6056C12.3278 36.8833 12.3278 56.8593 24.6056 69.1352C36.8833 81.413 56.8593 81.413 69.1352 69.1352C81.413 56.8574 81.413 36.8815 69.1352 24.6056C62.9981 18.4685 54.9333 15.3981 46.8704 15.3981Z",
    fill: "#364920"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 115.66,
    y: 95.5,
    width: 58.86,
    height: 58.86,
    viewBox: "0 0 58.8556 58.8556",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.4278 57.4667C44.9132 57.4667 57.4667 44.9132 57.4667 29.4278C57.4667 13.9423 44.9132 1.38889 29.4278 1.38889C13.9423 1.38889 1.38889 13.9423 1.38889 29.4278C1.38889 44.9132 13.9423 57.4667 29.4278 57.4667Z",
    fill: "#E8DEC4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.4278 58.8556C13.2019 58.8556 0 45.6537 0 29.4278C0 13.2018 13.2019 0 29.4278 0C45.6537 0 58.8556 13.2018 58.8556 29.4278C58.8556 45.6537 45.6537 58.8556 29.4278 58.8556ZM29.4278 2.77778C14.7333 2.77778 2.77778 14.7333 2.77778 29.4278C2.77778 44.1222 14.7333 56.0778 29.4278 56.0778C44.1222 56.0778 56.0778 44.1222 56.0778 29.4278C56.0778 14.7333 44.1222 2.77778 29.4278 2.77778Z",
    fill: "#304A19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.2019 44.25C16.8685 44.25 16.5333 44.1296 16.2667 43.8889C15.7 43.3722 15.6574 42.4944 16.1741 41.9278L40.6278 15.0593C41.1444 14.4926 42.0222 14.45 42.5889 14.9667C43.1556 15.4833 43.1982 16.3611 42.6815 16.9278L18.2278 43.7963C17.9537 44.0982 17.5778 44.25 17.2 44.25H17.2019Z",
    fill: "#304A19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.6556 44.25C41.2778 44.25 40.9019 44.0963 40.6278 43.7963L16.1741 16.9278C15.6574 16.3611 15.7 15.4815 16.2667 14.9667C16.8333 14.45 17.713 14.4926 18.2278 15.0593L42.6815 41.9278C43.1982 42.4944 43.1556 43.3741 42.5889 43.8889C42.3222 44.1315 41.9889 44.25 41.6537 44.25H41.6556Z",
    fill: "#304A19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.abe3c53763ea7928c4d77312a10e1393.svg";
export { ForwardRef as ReactComponent };